import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Defensive: remove any third-party badge that may be injected by host scripts.
(function purgePlatformBadge() {
  const purge = () => {
    document.querySelectorAll("#emergent-badge, a[href*='emergent.sh']").forEach((el) => {
      try { el.parentNode && el.parentNode.removeChild(el); } catch (e) { /* noop */ }
    });
  };
  purge();
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(purge).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
